module.exports = __webpack_public_path__ + "static/Feature5-d626e53ad998f737334ef28b7075f49a.jpg";